import React from "react";
import { connect } from "react-redux";
import { selectors as userSelectors } from "../../../../../redux/user";
import { Header as StyledHeader, FullName, Email } from "./styles";

const Header = ({ currentUser: { firstName, lastName, email } }) => (
  <StyledHeader>
    <FullName>
      {firstName} {lastName}
    </FullName>
    <Email>{email}</Email>
  </StyledHeader>
);

const mapStateToProps = state => ({
  currentUser: userSelectors.getUser(state)
});

export default connect(mapStateToProps)(Header);
